export const PHONE_TOOL_URL = 'https://phonetool.amazon.com/users/';
